import { createContext } from "react";

const DF_OT0014Context = createContext();

export { DF_OT0014Context };
